import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.setSearch || initialState;

export const selectSetSearch = createSelector([selectSlice], state => state);
